export const modalModule = {
  namespaced: true,
  state: () => ({
    modals: [],
    modalIndexToRemove: 0,
  }),
  mutations: {
    open(state, payload) {
      state.modals.push({
        cmp: payload.cmp,
        animation: payload.animation,
        style: payload.style,
        data: payload.data,
        size: payload.size, // INFO: full, popup
        callback: payload.callback,
        canBackrdopClose: payload.canBackrdopClose,
        isVisible: true,
      })
    },
    close(state, payload) {
      !!state.modals[payload.index].callback && payload.data
        ? state.modals[payload.index].callback(payload.data)
        : null
      state.modals.splice(payload.index, 1)
    },
    closeAllModals(state) {
      state.modals = []
    },
  },
  getters: {
    getModals: state => {
      return state.modals
    },
  },
}
